import React, { useEffect, useState } from 'react';
import { Shield, Lock, CreditCard, Leaf, Check } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
interface OfferSectionProps {
  id?: string;
  showUrgency?: boolean;
  showCountdown?: boolean;
  showGuarantee?: boolean;
  showPayment?: boolean;
  ctaText?: string;
}
export function OfferSection({
  id,
  showUrgency = true,
  showCountdown = false,
  showGuarantee = true,
  showPayment = true,
  ctaText = '🛒 RECLAMAR MI 80% DE DESCUENTO →'
}: OfferSectionProps) {
  const [viewers, setViewers] = useState(87);
  useEffect(() => {
    if (showUrgency) {
      const viewerInterval = setInterval(() => {
        setViewers(prev => prev + Math.floor(Math.random() * 3) - 1);
      }, 4000);
      return () => clearInterval(viewerInterval);
    }
  }, [showUrgency]);
  return <section id={id} className="py-12 px-4 max-w-[600px] mx-auto text-center relative" data-id="element-317">
      <div className="relative z-10" data-id="element-318">
        <div className="mb-6 relative rounded-xl overflow-hidden shadow-green-medium border border-[#E8DFD0] bg-white p-2" data-id="element-319">
          <img src="https://cdn.magicpatterns.com/uploads/iNEUHineDxK33A6JFu6xy2/mockup.png" alt="La Medicina Natural" className="w-full h-auto block rounded-lg" data-id="element-320" />
        </div>

        {/* Interior Preview */}
        <div className="mb-8 relative rounded-xl overflow-hidden border border-[#E8DFD0] bg-white shadow-sm" data-id="element-321">
          <div className="bg-[#F0F4EC] px-4 py-2 border-b border-[#E8DFD0] flex items-center gap-2" data-id="element-322">
            <span className="w-2 h-2 rounded-full bg-[#2D5A3D]" data-id="element-323"></span>
            <span className="text-xs font-bold text-[#2D5A3D] uppercase tracking-wider" data-id="element-324">
              Vista previa del contenido
            </span>
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/1cFjJ34ehCNBh8sw16hWnj/ChatGPT_Image_18_feb_2026,_09_44_05_p.m..png" alt="Vista interior de La Medicina Natural" className="w-full h-auto block" data-id="element-325" />
        </div>

        {/* Value Stack */}
        <div className="bg-white rounded-2xl p-6 mb-6 border border-[#2D5A3D] shadow-green-soft relative overflow-hidden" data-id="element-326">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#2D5A3D] to-[#4A8C5C]" data-id="element-327"></div>

          <div className="space-y-3 mb-6 text-left text-sm border-b border-[#E8DFD0] pb-6" data-id="element-328">
            <div className="flex justify-between items-center" data-id="element-329">
              <span className="text-[#2C1810] font-medium flex items-center gap-2" data-id="element-330">
                <Leaf className="w-4 h-4 text-[#2D5A3D]" data-id="element-331" /> La Medicina Natural
                — Manual Digital
              </span>
              <span className="text-[#5C4A3A] line-through" data-id="element-332">$149.00</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-333">
              <span className="text-[#2C1810] font-medium flex items-center gap-2" data-id="element-334">
                <Leaf className="w-4 h-4 text-[#2D5A3D]" data-id="element-335" /> Acceso Inmediato +
                Actualizaciones
              </span>
              <span className="text-[#2D5A3D] font-bold" data-id="element-336">INCLUIDO</span>
            </div>
          </div>

          <div className="flex flex-col items-center gap-1 leading-none mb-6" data-id="element-337">
            <div className="text-sm text-[#5C4A3A] font-medium mb-1" data-id="element-338">
              VALOR REAL: <span className="line-through" data-id="element-339">$149.00</span>
            </div>
            <div className="font-serif font-bold text-[48px] text-[#2D5A3D] tracking-tight mt-2" data-id="element-340">
              $6.97
            </div>
            <div className="text-xs text-[#8B7355] font-medium" data-id="element-341">
              Descarga digital instantánea
            </div>

            <div className="bg-[#B91C1C] text-white px-4 py-1 rounded-full font-bold text-[12px] uppercase mt-3 animate-pulse" data-id="element-342">
              🔥 Ahorras 95% Hoy
            </div>
          </div>

          <div className="flex justify-center gap-4 pt-6 border-t border-[#E8DFD0] text-[#5C4A3A] text-xs font-bold" data-id="element-343">
            <div className="flex items-center gap-1.5" data-id="element-344">
              <Shield className="w-4 h-4 text-[#2D5A3D]" data-id="element-345" /> Garantía 7 Días
            </div>
            <div className="flex items-center gap-1.5" data-id="element-346">
              <CreditCard className="w-4 h-4 text-[#2D5A3D]" data-id="element-347" /> Pago Seguro
            </div>
          </div>
        </div>

        {showUrgency && <div className="flex flex-col gap-3 mb-6" data-id="element-348">
            <div className="bg-[#F0F4EC] text-[#2D5A3D] text-sm p-3 rounded-lg border border-[#2D5A3D]/20 flex items-center justify-center gap-2" data-id="element-349">
              <span className="w-2 h-2 bg-[#166534] rounded-full animate-pulse" data-id="element-350"></span>
              <strong data-id="element-351">{viewers} personas</strong> ven esta página ahora mismo
            </div>
            <div className="text-xs text-[#B91C1C] font-bold" data-id="element-352">
              ⚠️ El precio de $6.97 es por tiempo limitado
            </div>
          </div>}

        <a href="https://oriammarketing.com/cart/45549196902598:1" onClick={() => trackAddToCart()} className="block w-full bg-gradient-to-r from-[#2D5A3D] to-[#1B4332] text-[#FEFCF6] font-bold py-5 px-6 rounded-xl text-xl uppercase tracking-wide shadow-[0_4px_14px_0_rgba(45,90,61,0.39)] hover:shadow-[0_6px_20px_rgba(45,90,61,0.23)] hover:-translate-y-1 transition-all duration-300 animate-pulse-green mb-6" data-id="element-353">
          {ctaText}
        </a>

        {showPayment && <div className="flex flex-col items-center gap-2 text-center" data-id="element-354">
            <div className="flex items-center justify-center gap-2 text-xs text-[#5C4A3A]" data-id="element-355">
              <Shield className="w-3 h-3 text-[#2D5A3D]" data-id="element-356" /> Garantía 7 Días
            </div>
            <div className="flex gap-3 opacity-70 grayscale hover:grayscale-0 transition-all" data-id="element-357">
              {['VISA', 'MC', 'AMEX', 'PAYPAL'].map(card => <span key={card} className="text-[10px] border border-[#E8DFD0] px-2 py-1 rounded text-[#5C4A3A] font-bold bg-white" data-id="element-358">
                  {card}
                </span>)}
            </div>
          </div>}
      </div>
    </section>;
}